export default __webpack_public_path__ + "static/media/1875.fe34eef7.png";